import React, { FC, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, SecondaryButton, PrimaryButton } from 'application/components';
import { LogoIcon } from 'application/assets';

import { ConfirmModalProps } from './models';
import { FormStyled, ButtonsSection, SpinnerWrapper } from './styles';

/**
 * Functional component for displaying a confirm modal.
 *
 * @param opened - Determines if the modal should be visible.
 * @param onClose - Callback function to close the modal.
 * @param onSubmit - Callback function to handle form submission.
 * @param children - React nodes to display inside the modal body.
 * @param styleType - Optional string indicating the style of the primary button.
 * @param isLoading - Determines if the loader should be visible.
 */
const ConfirmModal: FC<ConfirmModalProps> = ({
  opened,
  onClose,
  onSubmit,
  children,
  styleType = 'default',
  isLoading,
}) => {
  const { t } = useTranslation();
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(event);
  };

  return (
    <Modal opened={opened} onClose={onClose}>
      <FormStyled onSubmit={handleSubmit}>
        {children}
        <ButtonsSection>
          <SecondaryButton type="button" onClick={onClose} disabled={isLoading}>
            {t('global.cancel')}
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            styleType={styleType}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                {/* <SpinnerWrapper>
                  <LogoIcon />
                </SpinnerWrapper> */}
                {t('global.loading', { defaultValue: 'Processing...' })}
              </>
            ) : (
              t('global.confirm')
            )}
          </PrimaryButton>
        </ButtonsSection>
      </FormStyled>
    </Modal>
  );
};

export default ConfirmModal;
